import User from "../../../model2/user/user";
import {ProjectAccess} from "../../../gd/const/project";
import {ModelInterface} from "../../../data-structures/collection";
import CompanyUser from "../../../model2/company-user-new/company-user";


export default class UserToAdd implements ModelInterface {

    public id               : ID
    public user             : User
    public companyUser      : CompanyUser
    public isSelected       : boolean = false

    public workspaceAccess? : ProjectAccess
    public projectAccess?   : ProjectAccess


    constructor(companyUser:CompanyUser) {

        this.id             = companyUser.user.id
        this.user           = companyUser.user
        this.companyUser    = companyUser
    }

    toggleIsSelected():void {
        this.isSelected = !this.isSelected
    }

    unselect(): void {
        this.isSelected = false
    }

    toJSON():JSONObject {
        return {
            id                  : this.id,
            isSelected          : this.isSelected,
            workspaceAccess     : this.workspaceAccess,
            projectoAccess      : this.projectAccess,
        }
    }



}